module.exports = __webpack_public_path__ + "img/xiugaitouxiang_bg.3ada5d53.png";